import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/pub/centroscustos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const getCentroCusto = async ({ empresa_cnpj, per_page = 100 }) =>
  search(
    `${path}?empresa_cnpj=${empresa_cnpj}&per_page=${per_page}`,
    "GET",
    headers
  );
